<!-- Table Container -->
<div class="h-100 d-flex flex-column">
  @if (selectedSchedule(); as schedule) {
    <!-- Buttons -->
    <div class="d-flex justify-content-end align-items-center w-100 gap-3 mh-70p">
      <button
        type="button"
        placement="top"
        class="btn btn-circle btn-lg btn-ghost element-plus"
        aria-label="addTrackToSchedule"
        [siTooltip]="'SCHEDULE.ADD_TRACK_TOOLTIP' | translate"
        [disabled]="!allTrackVersionsAccessible()"
        (click)="openLoadTrackModalClicked.emit()"
      ></button>
      <button
        type="button"
        class="btn btn-circle btn-lg btn-ghost element-repeat"
        placement="top"
        aria-label="reverse"
        [siTooltip]="'SHARED.REVERSE' | translate"
        [disabled]="schedule.tracks.length <= 1 || !allTrackVersionsAccessible()"
        (click)="reverseSchedule()"
      ></button>
    </div>

    @if (schedule.tracks.length === 0) {
      <div class="d-flex justify-content-center align-items-center h-100 overflow-auto">
        <si-empty-state
          empty-content
          icon="element-technical-operator"
          [heading]="'SCHEDULE.INFO_NO_TRACKS_EXISTING' | translate"
        />
      </div>
    } @else {
      <div class="drag-boundary d-flex flex-column gap-5 h-100 w-100 overflow-auto">
        <div cdkDropList class="h-100 overflow-auto" (cdkDropListDropped)="onTrackDrop($event)">
          @for (track of schedule.tracks; track $index; let trackIndex = $index) {
            <si-collapsible-panel
              class="pb-0 w-100"
              headerCssClasses="p-3"
              cdkDrag
              colorVariant="base-1"
              cdkDragBoundary=".drag-boundary"
              [cdkDragData]="trackIndex"
            >
              <div
                class="d-flex justify-content-between align-items-center w-100 gap-3"
                si-panel-heading
              >
                <button
                  cdkDragHandle
                  type="button"
                  aria-label="track-options"
                  class="btn btn-circle btn-lg btn-ghost element-menu align-self-end ml-auto"
                  (click)="$event.stopPropagation()"
                ></button>
                <span class="flex-grow-1 w-100 text-justify">{{
                  track.trackParameters
                    ? (track.scheduleData.stoppingData[0].trackName | starPrefix)
                    : track.scheduleData.stoppingData[0].trackName
                }}</span>
                @if (!isTrackVersionAccessible(linkIdByTrackIndex()[trackIndex])) {
                  <i
                    class="icon element-warning text-warning"
                    aria-label="track-version-not-accessible"
                    [siTooltip]="'SCHEDULE.TRACK_VERSION_NOT_ACCESSIBLE' | translate"
                  ></i>
                }
                @if (hasTrackVersions(linkIdByTrackIndex()[trackIndex])) {
                  <si-select
                    labelledby="multi-select"
                    class="w-50 form-control"
                    placeholder="Select Version"
                    [options]="getTrackVersionOptionsByLinkId(linkIdByTrackIndex()[trackIndex])"
                    [ngModel]="getSelectedVersionByLinkId(linkIdByTrackIndex()[trackIndex])"
                    [disabled]="isTrackVersionChangePending(linkIdByTrackIndex()[trackIndex])"
                    [class.is-invalid]="!isTrackVersionAccessible(linkIdByTrackIndex()[trackIndex])"
                    (ngModelChange)="
                      onTrackVersionChangeByLinkId(linkIdByTrackIndex()[trackIndex], $event)
                    "
                    (click)="
                      onDropdownClick(trackIndex); $event.stopPropagation(); $event.preventDefault()
                    "
                  />
                }
                <button
                  type="button"
                  aria-label="track-options"
                  class="btn btn-circle btn-lg btn-ghost element-options"
                  [cdkMenuTriggerFor]="contextMenu"
                  [cdkMenuTriggerData]="{
                    trackIndex: trackIndex
                  }"
                  [disabled]="!allTrackVersionsAccessible()"
                  (click)="$event.stopPropagation()"
                ></button>
              </div>
              <div class="w-100 overflow-x-auto overflow-y-hidden w-100 overflow-auto">
                <table class="table table-hover table-sm mt-2">
                  <thead>
                    <tr>
                      <th scope="col">{{ 'SCHEDULE.COLUMN_NAMES.STATION_NAME' | translate }}</th>
                      <th scope="col">{{ 'SCHEDULE.COLUMN_NAMES.STOPPING_TIME' | translate }}</th>
                      <th scope="col">{{ 'SCHEDULE.COLUMN_NAMES.STOPPING_ACTION' | translate }}</th>
                      <th scope="col">{{ 'SCHEDULE.COLUMN_NAMES.DO_NOT_STOP' | translate }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    @for (
                      stoppingData of track.scheduleData.stoppingData;
                      track $index;
                      let i = $index
                    ) {
                      <tr class="w-100">
                        <td>{{ stoppingData.stationName }}</td>
                        <td>
                          <si-number-input
                            id="stoppingTime"
                            inputId="exampleInput"
                            class="form-control"
                            [(ngModel)]="stoppingData.stoppingTime"
                          />
                        </td>
                        <td>
                          <si-select
                            labelledby="single-select"
                            single
                            class="w-100 form-control"
                            [placeholder]="'SCHEDULE.SELECT_OPTION_PLACEHOLDER' | translate"
                            [options]="availableStoppingActions()"
                            [ngModel]="getStoppingActionDisplayValue(stoppingData)"
                            (ngModelChange)="onStoppingActionChange(stoppingData, $event)"
                            (click)="$event.stopPropagation(); $event.preventDefault()"
                          />
                        </td>
                        <td>
                          <input
                            type="checkbox"
                            class="form-check-input"
                            [(ngModel)]="stoppingData.doNotStopAtStation"
                          />
                        </td>
                      </tr>

                      @if (track.scheduleData.drivingData[i]) {
                        <tr class="w-100">
                          <td class="w-100 d-flex align-items-center justify-content-center py-0">
                            <i class="icon element-options-vertical d-block"></i>
                            <si-number-input
                              inputId="drivingTime"
                              class="form-control"
                              [(ngModel)]="track.scheduleData.drivingData[i].drivingTime"
                            />
                          </td>

                          <td>
                            <si-select
                              labelledby="multi-select"
                              multi
                              class="form-control"
                              [placeholder]="'SCHEDULE.SELECT_OPTION_PLACEHOLDER' | translate"
                              [options]="availableDrivingActions()"
                              [(ngModel)]="track.scheduleData.drivingData[i].drivingActions"
                            />
                          </td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                        </tr>
                      }
                    }
                  </tbody>
                </table>
              </div>
            </si-collapsible-panel>
          }
        </div>
      </div>
    }
  }
</div>

<ng-template #contextMenu let-index="trackIndex">
  <si-menu-factory [items]="contextMenuItems" [actionParam]="index" />
</ng-template>
